import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../Box/index.js";
const Descriptions = (t0)=>{
    const $ = c(3);
    const { children, gapBetweenItems: t1 } = t0;
    const gapBetweenItems = void 0 === t1 ? "8" : t1;
    let t2;
    if ($[0] !== children || $[1] !== gapBetweenItems) {
        t2 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexDirection: "column",
            gap: gapBetweenItems,
            p: "16",
            bgcolor: "bg.greyscale.primary",
            radius: "l",
            testId: "descriptions-test-id",
            children: children
        });
        $[0] = children;
        $[1] = gapBetweenItems;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
export { Descriptions };
